import { ApplicationEnvironment } from '../../entities/catalog/application.environment';
import { EnvironmentConfiguration } from './environment.configuration';

export const environmentReleaseCandidate = {
  locale: 'en-AU',
  production: true,
  api: '/api',
  domain: 'workbuddy.live',
  auth: {
    local: {
      callbackUrl: 'http://{0}:4000/callback',
    }
  },
  jms: {
    loginHref: 'https://id.workbuddy.live',
    logoutHref: 'https://id.workbuddy.live/logout',
    captcha: '6LfQ01oUAAAAAFfG2a8ZR509QugrxclKGsINjcKN',
    captchaSecret: '6LfQ01oUAAAAAFfjjGsSDeMfCc9ZPTAMswBcBh8y',
  },
  sentry: {
    dsn: '',
    name: '',
    release: '',
    environment: ''
  },
  environment: ApplicationEnvironment.ReleaseCandidate
} as EnvironmentConfiguration;